import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Ring } from "@uiball/loaders";
import { useSelector } from "react-redux";

import { colors } from "../../../../../consts";

import {
  EditButtonsGroup,
  FlexContainers,
  GradientLoader,
  IconButton,
  SVG,
  WrapperContainer
} from "../../../../../components";

const ControlButtons = ({
  fwuVersion,
  isLoading,
  isValid,
  isNewRow,
  isEditingRow,
  onDeleteFirmwareVersion,
  onFinish
}) => {
  const loadingChanges = useSelector((state) => state.fwuVersions?.loadingChanges);
  const isRowLoading = useMemo(() => {
    return loadingChanges && (isNewRow || isEditingRow);
  }, [loadingChanges, isNewRow, isEditingRow]);

  return (
    <WrapperContainer Container={FlexContainers.FlexRowEnd} width="100%">
      {isLoading ? (
        <GradientLoader width={70} height={24} animationDuration={48} />
      ) : isRowLoading ? (
        <WrapperContainer Container={FlexContainers.FlexRowCenter} pr={20}>
          <Ring size={34} lineWeight={5} speed={2} color={colors.RAISIN_100} />
        </WrapperContainer>
      ) : isNewRow || isEditingRow ? (
        <EditButtonsGroup
          isEdit={false}
          disableAccept={!isValid}
          handleCancel={(e) => {
            e.stopPropagation();
            onFinish(false);
          }}
          handleAccept={(e) => {
            e.stopPropagation();
            onFinish(true);
          }}
        />
      ) : (
        <WrapperContainer Container={FlexContainers.FlexRowEnd}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onDeleteFirmwareVersion(fwuVersion);
            }}
            disabled={loadingChanges}
            hasHoverCircle
            isLarge>
            <SVG.DeleteIcon />
          </IconButton>
        </WrapperContainer>
      )}
    </WrapperContainer>
  );
};

ControlButtons.propTypes = {
  fwuVersion: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  isNewRow: PropTypes.bool.isRequired,
  isEditingRow: PropTypes.bool.isRequired,
  onDeleteFirmwareVersion: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired
};

export default ControlButtons;
